import { getDictionary, isHot97 } from "@/src/dictionary"
import Section from "../../Section"
import { useEffect, useState } from "react"
import { BUILD_INTERVAL_TD_PLAYER, BUY_SVG_ICON } from "../../utils/listen-live"

const SongHistory = () => {
     
    const [isLoading, setisLoading] = useState(true)
    //customiziation for the td-songhistory component
    useEffect(() => {
        //  var my_awesome_script = document.createElement('script');
        // document.querySelector("script[src='https://widgets.listenlive.co/1.0/tdwidgets.min.js']")?.remove()
        // my_awesome_script.setAttribute('src','https://widgets.listenlive.co/1.0/tdwidgets.min.js');
        // document.head.appendChild(my_awesome_script);
        let header = document.querySelector('#td-songhistory')
        setTimeout(() => {            
            header?.classList?.add('w-full');
            // remove header
            document.querySelectorAll('.td-song-history__header').forEach((node) => node.remove());
            // add padding and change buy icon
            document.querySelectorAll('.td-song-history__song')?.forEach((node) => {
                node.classList.add('border-0', 'mb-4');
                if (node?.lastElementChild?.firstElementChild) {
                    node.lastElementChild.firstElementChild.innerHTML = BUY_SVG_ICON
                }
            })
            // change colors
            document.querySelectorAll('.td-song-history__song__infos')?.forEach((node) => {
                node.classList.add('pl-4');
                node.lastElementChild?.querySelector('.td-song-history__song__infos__cue-title')?.firstElementChild?.classList.add('!text-hot-yellow')
            });

            let barSong = document.querySelector('#td-player-desktop');
            barSong?.classList.add('w-full');
            barSong?.firstElementChild?.firstElementChild?.classList.add('flex', 'justify-between', 'items-center');
            let buyButtonBar = document.querySelector('.td-player-bar__buy')?.lastElementChild;
            if (buyButtonBar) {
                buyButtonBar.innerHTML = BUY_SVG_ICON
            }

            // TODO: Find a better way with Next JS Layout structure
            var content = document.querySelector('#songhistory-content');
            if (content) {
                content.innerHTML = document.querySelector('#td-songhistory')?.innerHTML || '';
            }

            setisLoading(false)
        }, BUILD_INTERVAL_TD_PLAYER)

        
    }, [])

    return (
        <Section
            key={'recently-played'}
            title='Recently Played'
            showHeader
            sectionStyle="px-12 py-12 bg-body"
        >
            
        <div className={isLoading ? 'hidden' : 'flex'} id="songhistory-content">        
        </div>
            <div className={`flex-col gap-4 w-[92vw] p-2 pr-12 ${isLoading ? 'flex' : 'hidden'}`}>
            <div className='skeleton h-4 w-full'></div>
            <div className='skeleton h-4 w-full'></div>
            <div className='skeleton h-4 w-full'></div>
            <div className='skeleton h-4 w-full'></div>
            <div className='skeleton h-4 w-full'></div>
            <div className='skeleton h-4 w-full'></div>
            </div>
        </Section>
    )
}

export default SongHistory